import { Fragment, useEffect, useRef, useState } from "react";
import {
    addAssets,
  addCommodities,
  editCommodities,
  getCommodities,
} from "../../homepurchase.service";
import { useMediaQuery } from "react-responsive";
import {
  useNavigate,
  useOutletContext,
  useSearchParams,
} from "react-router-dom";
import { SuccessToastConfig } from "app/utils/ToastConstants";
import { ErrorToastConfig } from "app/utils/ToastConstants";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { Loading } from "app/components";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { formatDate } from "app/utils/utility.service";
import { getSessionUserInformation } from "app/utils/utility.service";
import { InputNumber } from "primereact/inputnumber";
import { NumericFormat } from "react-number-format";
import { formatNumber } from "app/utils/utility.service";

const AddAssets = ({
  assetsModal,
  handleAddAssetsModal,
  categories,
  fetchAccounts,
  title
}) => {
  const toast = useRef();
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [searchParams] = useSearchParams();
   const [values, setValues] = useState();
  const sessionValues = getSessionUserInformation();
  const clientId = searchParams.get("clientid");
  const [isLoading, setIsLoading] = useState(false);
  const [exists, setExists] = useState(false);
  const userId = clientId && clientId !== "null" ? clientId : sessionValues.id;
  const onHide = () => {
    setFormSubmitted(false);
    handleAddAssetsModal(false);
  };
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });

  const showSuccess = (message) => {
    toast.current.show(SuccessToastConfig(message));
  };
  const showError = (message) => {
    toast.current.show(ErrorToastConfig(message ? message : "Error"));
  };
  const validateInput = () => {
    if (
      !values.account_name 
    ) {
      return false;
    }
    const exists = categories.some(
      category => category.account_name.toLowerCase() === values.account_name.toLowerCase()
    );
    if(exists) {
      setExists(true);
      return false;
    } else {
      setExists(false);
    }
    return true;
  };
 

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value   
    });
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);

    if (!validateInput()) {
      return false;
    }

    let details;
    setIsLoading(true);
    let req = values;
    req.userId = userId;
    req.type=title;
    details = await addAssets(req);
   
    if (details) {
      showSuccess("Account added successfully");
     
      setTimeout(() => {
        onHide();
        fetchAccounts();
      }, 1000);
    } else {
      showError(details?.message);
    }
    setIsLoading(false);
  };
  const renderFooter = () => {
    return (
      <div>
        <div className="grid">
          <div className="col-3"></div>
          <div
            className={`${
              isDesktopOrLaptop ? "col-7" : "col-12 text-align-center"
            }`}
          >
            <Button
              label="Cancel"
              className="p-button-raised p-button-lg"
              onClick={() => onHide()}
            />
            <Button
              type="submit"
              label="Add"
              className={`p-button-raised p-button-warning p-button-lg  ${
                isDesktopOrLaptop ? "" : "ml-4"
              }`}
              onClick={handleSubmit}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <Dialog
      header={"Add Account"}
      visible={assetsModal}
      onHide={() => onHide()}
      breakpoints={{ "960px": "75vw" }}
      style={{ width: "35vw" }}
      footer={renderFooter()}
      className="AnnualExpenseModal"
      position="top"
      closeOnEscape={false}
      draggable={false}
    >
      <div className="center-align">
        {isLoading && <Loading />}
        <Toast ref={toast} className="ToastMessage" />
        <div className="AddPropertyForm">
          <div className={`mt-4 ${isDesktopOrLaptop ? "text-right" : ""}`}>
            <div className="grid" style={{justifyContent:"center"}}>
            
              <div className={`${isDesktopOrLaptop ? "col-9" : "col-11"}`}>
                <div className="field">
                  <div className="p-inputgroup">
                    <span className="p-float-label">
                      <InputText
                        className="vw-inputtext-with-border"
                        autoComplete="off"
                        required={true}
                        name="account_name"
                        value={values?.account_name}
                        onChange={handleInputChange}
                      />
                    </span>
                  </div>
                  <div className="text-align-left">
                    {formSubmitted && !values?.account_name && (
                      <small className="p-error">
                        Please enter account name
                      </small>
                    )}
                     {formSubmitted && exists && (
                      <small className="p-error">
                        Account name already exists. 
                      </small>
                    )}
                  </div>
                </div>
              </div>
           </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};
export default AddAssets;
